<template>
  <div>
    <v-card flat min-height="100" :loading="criticalSlidesLoaded">
      <v-card-subtitle class="mx-auto pt-0">
      <span class="font-weight-bold subtitle-2 mx-n4 pt-0">
        {{ $vuetify.lang.t(`$vuetify.criticalDataset.labels.${CriticalDatasetLabels.SLIDES}`) }}
      </span>
      </v-card-subtitle>
      <v-card-text v-show="!criticalSlidesLoaded">
        <template v-if="!criticalSlidesFailed">
          <v-item-group v-model="localSlides" multiple>
            <v-row justify="center">
              <v-col
                v-for="(item) in indexList"
                :key="item"
                cols="12"
                md="4"
                align-self="center"
              >
                <v-item v-slot="{ active, toggle }">
                  <v-img
                    :src="slideImage(item)"
                    height="350"
                    class="pa-1"
                    @click="toggle"
                  >
                    <v-btn
                      icon
                      dark
                      color="orange"
                    >
                      <v-icon>
                        {{ active ? checkedIcon : uncheckedIcon }}
                      </v-icon>
                    </v-btn>
                  </v-img>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </template>
        <template v-else>
          <v-alert type="error" dense text>
            {{ $vuetify.lang.t(`$vuetify.criticalDataset.slides.alert`) }}
          </v-alert>
        </template>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>

import { getSite } from '@/utils/path'
import {
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedCircle,
  mdiCheckboxMarkedCircleOutline
} from '@mdi/js'
import { CriticalDatasetLabels } from '@/enum'

const slideSize = 5

export default {
  name: 'criticalDatasetSlides',
  props: {
    slides: Array,
    criticalSlidesLoaded: Boolean,
    criticalSlidesFailed: Boolean,
    user: Number,
    tripStart: Number,
    timestamp: Number
  },
  data: () => ({
    slideSize: slideSize,
    indexList: [...Array(slideSize).keys()],

    checkedIcon: mdiCheckboxMarkedCircle,
    uncheckedIcon: mdiCheckboxBlankCircleOutline
  }),
  computed: {
    localSlides: {
      get () {
        return this.slides
      },
      set (value) {
        this.$emit('slides-changed', value)
      }
    }
  },
  methods: {
    slideImage (slide) {
      return `${getSite()}map/get_critical_slide?user=${this.user}&trip_start=${this.tripStart}&timestamp=${this.timestamp}&slide=${slide}`
    }
  },
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
